import { geoApi } from '../utils/axios';

export const getCoordinatesByPostcode = async (postcode) => {
  const location = await geoApi.get(`/postcodes/${postcode}`);

  const {
    longitude = null,
    latitude = null,
  } = location?.data?.result || {};

  return { longitude, latitude };
};
